import React, {Component} from 'react'
import {connect} from 'react-redux'
import Resources from '../../../data/services/resources'
import IntegratedMoneyCodesView from './integratedMoneyCodesTab'
import MoneyCodesView from './moneyCodesTab'
import Page from "../../../common/components/layout/layout-components/page";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import NavResponsive from "../../../common/components/nav-responsive";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import Layout from "../../../common/components/layout";

class MoneyCodesPage extends Component {

    constructor(props) {
        super(props)
        const tabs = [
            {
                name: 'MoneyCodes',
                resource: Resources.MoneyCodes,
                current: true,
                visible: true
            },
            {
                name: 'IntegratedMoneyCodes',
                resource: Resources.MoneyCodesIntegrated,
                current: false,
                visible: true
            }
        ]

        this.state = {
            tabs: tabs,
            selectedTab: Resources.MoneyCodes,
            breakpoint: {}
        }
    }

    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }

        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }
    handleBreakpointChange = (breakpoint) => {
        this.setState({
            breakpoint
        })
    }

    render() {
        const {translate, resource} = this.props

        return (
            <Layout
                onBreakpoinChange={this.handleBreakpointChange}
                isAccessible={!(resource.errorStatus === 2)}
                {...this.props}
            >
                <Page>
                    <PageHeader
                        title={translate('page.heading.MoneyCodes')}
                        afterTitle={(
                            <PageHeaderInfo
                                dispatch={this.props.dispatch}
                            />
                        )}
                    />

                    <div className="hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div className="">
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    {this.state.selectedTab === Resources.MoneyCodesIntegrated && (
                        <IntegratedMoneyCodesView
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.MoneyCodes && (
                        <MoneyCodesView
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}
                </Page>
            </Layout>
        )
    }
}

export default connect(state => state)(MoneyCodesPage)
